import { List, ListItem, Row, Stars, Typography } from 'darrius';
import { type IRatingReturn } from '../../../modules/profile/shared/pageProps/getRatingProps/@interfaces';

import styles from './ProfileRating.module.scss';
interface IProfileRatingProps {
  rating: IRatingReturn;
}

export const ProfileRating = ({ rating }: IProfileRatingProps) => {
  if (!rating) return null;

  return (
    <Row>
      <section className="rating space-top" id={rating.id}>
        <Typography.Subtitle size="l" className={styles['rating__title']}>
          {rating.title}
        </Typography.Subtitle>
        <div
          className={`${styles['rating-resume']} no-margin-bottom center-items`}
        >
          <Stars
            size="small"
            rating={rating.total}
            quantity={rating.items.length}
            showText={true}
          />
          <Typography.Text>{rating.quantity} avaliações</Typography.Text>
        </div>
        <List className={styles.rating__list}>
          {rating.items.map((item) => (
            <ListItem key={item.star} className="center-items no-margin-bottom">
              <Stars quantity={item.quantity} size="small" />
              <Typography.Text>{item.star} estrelas</Typography.Text>
              <Typography.Text>: {item.quantity} avaliações</Typography.Text>
            </ListItem>
          ))}
        </List>
      </section>
    </Row>
  );
};
